import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useCurrentLanguage from '@/shared/hooks/useCurrentLanguage';
import { DEFAULT_LANGUAGE } from '@/features/LanguageWrapper';

const COOKIE_CONSENT_KEY = 'cookieConsent';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(
    () => !!localStorage.getItem(COOKIE_CONSENT_KEY)
  );
  const lng = useCurrentLanguage();
  const langPrefix = lng !== DEFAULT_LANGUAGE ? `/${lng}` : '';

  if (accepted) return null;

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setAccepted(true);
  };

  return (
    <div className='cookie-banner'>
      <p className='cookie-banner__text'>
        {t('cookieBanner.messageBefore')}
        <Link to={`${langPrefix}/politica`} className='cookie-banner__link'>
          {t('cookieBanner.cookieWord')}
        </Link>
        {t('cookieBanner.messageAfter')}
      </p>
      <button className='cookie-banner__btn' onClick={handleAccept}>
        {t('cookieBanner.accept')}
      </button>
    </div>
  );
};

export default CookieBanner;
